import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Null } from "./Null.mjs";
/**
 * @name DoNotConstruct
 * @description
 * An unknown type that fails on construction with the type info
 */

export var DoNotConstruct =
/*#__PURE__*/
function (_Null) {
  _inherits(DoNotConstruct, _Null);

  function DoNotConstruct(registry) {
    var _this;

    var typeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DoNotConstruct';

    _classCallCheck(this, DoNotConstruct);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DoNotConstruct).call(this, registry));
    throw new Error("Cannot construct unknown type ".concat(typeName));
    return _this;
  }

  _createClass(DoNotConstruct, null, [{
    key: "with",
    value: function _with(typeName) {
      return (
        /*#__PURE__*/
        function (_DoNotConstruct) {
          _inherits(_class, _DoNotConstruct);

          function _class(registry) {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, registry, typeName));
          }

          return _class;
        }(DoNotConstruct)
      );
    }
  }]);

  return DoNotConstruct;
}(Null);